import React, { useEffect, useState } from 'react'
import { Content } from '../../components'
import { WelcomePage } from './components/welcome-page'
import { editorials } from './editorials/articles'
import { MailchimpForm } from './components/mailchimp-form'

export const NewsletterPage = () => {
  const [hasJoined, setHasJoined] = useState(false)
  useEffect(() => {
    if (hasJoined) {
      window.scrollTo(0, 0)
    }
  }, [hasJoined])
  const questionsArticle = editorials.find(
    (article) =>
      article.title === 'Questions to Ask Before Placing a Custom-Made Order'
  )

  const processArticle = editorials.find(
    (article) => article.slug === 'how-the-custom-made-process-works'
  )

  if (hasJoined) {
    return <WelcomePage />
  }

  return (
    <Content padding="0">
      <main
        style={{
          width: '100%',
          backgroundColor: '#f3efe7',
          color: '#171714',
          fontFamily: 'Georgia, "Times New Roman", serif'
        }}
      >
        {/* Magazine cover */}
        <section
          style={{
            minHeight: 'calc(100vh - 80px)',
            padding: '28px clamp(20px, 5vw, 72px) 48px',
            display: 'flex',
            flexDirection: 'column',
            borderBottom: '1px solid #171714'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              gap: '24px',
              paddingBottom: '18px',
              borderBottom: '1px solid #171714',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '11px',
              letterSpacing: '2px',
              textTransform: 'uppercase'
            }}
          >
            <span>OvafloPick Editorial</span>
            <span>Weekly Publication</span>
          </div>

          <header
            style={{
              padding: '24px 0 18px',
              textAlign: 'center',
              borderBottom: '1px solid #171714'
            }}
          >
            <h1
              style={{
                margin: 0,
                fontSize: 'clamp(56px, 13vw, 190px)',
                lineHeight: '0.78',
                fontWeight: 400,
                letterSpacing: '-0.07em',
                textTransform: 'uppercase'
              }}
            >
              Made to Wear
            </h1>

            <p
              style={{
                margin: '22px 0 0',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '12px',
                letterSpacing: '4px',
                textTransform: 'uppercase'
              }}
            >
              By OvafloPick
            </p>
          </header>

          <div
            style={{
              flex: 1,
              display: 'grid',
              gridTemplateColumns:
                'repeat(auto-fit, minmax(min(100%, 280px), 1fr))',
              gap: 'clamp(32px, 6vw, 90px)',
              alignItems: 'end',
              paddingTop: '48px'
            }}
          >
            <div>
              <p
                style={{
                  maxWidth: '620px',
                  margin: 0,
                  fontSize: 'clamp(28px, 4.7vw, 68px)',
                  lineHeight: '1.02',
                  letterSpacing: '-0.035em'
                }}
              >
                Exceptional style begins with exceptional craftsmanship
              </p>
            </div>

            <div
              style={{
                maxWidth: '540px',
                justifySelf: 'end'
              }}
            >
              <p
                style={{
                  margin: '0 0 22px',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '17px',
                  lineHeight: '1.75'
                }}
              >
                Own clothes, shoes and accessories that speak luxury and high
                quality, crafted with intention by top class custom makers
              </p>

              <p
                style={{
                  margin: '0 0 32px',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '17px',
                  lineHeight: '1.75'
                }}
              >
                Collaborate with talented Artisans and Craftsmen in Africa to
                create timeless designs that belong right in your wardrobe
              </p>

              <p
                style={{
                  margin: '0 0 32px',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '17px',
                  lineHeight: '1.75'
                }}
              >
                 Move in everyday confidence. Made One of One.
              </p>

              <a
                href="#join-made-to-wear"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: '52px',
                  padding: '0 28px',
                  backgroundColor: '#171714',
                  color: '#f3efe7',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '12px',
                  fontWeight: 600,
                  letterSpacing: '2px',
                  textDecoration: 'none',
                  textTransform: 'uppercase'
                }}
              >
                Join Made to Wear
              </a>
            </div>
          </div>
        </section>

        {/* Editorial statement */}
        <section
          style={{
            padding: '96px clamp(20px, 7vw, 110px)',
            backgroundColor: '#171714',
            color: '#f3efe7'
          }}
        >
          <div
            style={{
              maxWidth: '1100px',
              margin: '0 auto'
            }}
          >
            <p
              style={{
                margin: '0 0 24px',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '11px',
                letterSpacing: '3px',
                textTransform: 'uppercase'
              }}
            >
              The publication
            </p>

            <p
              style={{
                maxWidth: '950px',
                margin: 0,
                fontSize: 'clamp(28px, 4.5vw, 60px)',
                lineHeight: '1.1',
                letterSpacing: '-0.025em'
              }}
            >
              A weekly discussion that celebrates great craftsmanship,
              inidvidual style that elevates your look, and the people creating
              fashion with purpose
            </p>
          </div>
        </section>

        {/* What readers receive */}
        <section
          style={{
            padding: '100px clamp(20px, 7vw, 110px)',
            borderBottom: '1px solid #171714'
          }}
        >
          <div
            style={{
              maxWidth: '1250px',
              margin: '0 auto'
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  'repeat(auto-fit, minmax(min(100%, 280px), 1fr))',
                gap: '36px',
                marginBottom: '64px'
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '11px',
                  letterSpacing: '3px',
                  textTransform: 'uppercase'
                }}
              >
                Inside every issue
              </p>

              <h2
                style={{
                  margin: 0,
                  fontSize: 'clamp(42px, 6.5vw, 90px)',
                  lineHeight: '0.92',
                  fontWeight: 400,
                  letterSpacing: '-0.055em'
                }}
              >
                As a member, you&apos;ll receive
              </h2>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  'repeat(auto-fit, minmax(min(100%, 220px), 1fr))',
                borderTop: '1px solid #171714',
                borderLeft: '1px solid #171714'
              }}
            >
              {[
                {
                  number: '01',
                  title: 'Thoughtful Insights',
                  text: 'Exploring craftsmanship, design and the future of custom-made fashion.'
                },
                {
                  number: '02',
                  title: 'Practical Buying Guides',
                  text: 'Helping you purchase custom-made clothing, shoes and accessories with confidence.'
                },
                {
                  number: '03',
                  title: 'Behind the Craft',
                  text: 'A closer look at the materials, techniques and traditions behind exceptional work.'
                },
                {
                  number: '04',
                  title: 'Meet Remarkable Makers',
                  text: 'Stories celebrating designers, artisans and custom makers from all over Africa.'
                },
                {
                  number: '05',
                  title: 'Wardrobe Inspiration',
                  text: 'Ideas for building a timeless wardrobe defined by good quality, personal style and longevity.'
                }
              ].map((item) => (
                <article
                  key={item.number}
                  style={{
                    minHeight: '260px',
                    padding: '28px',
                    borderRight: '1px solid #171714',
                    borderBottom: '1px solid #171714',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <span
                    style={{
                      fontFamily: 'Arial, Helvetica, sans-serif',
                      fontSize: '11px',
                      letterSpacing: '2px'
                    }}
                  >
                    {item.number}
                  </span>

                  <h3
                    style={{
                      margin: 'auto 0 18px',
                      fontSize: '28px',
                      lineHeight: '1.05',
                      fontWeight: 400
                    }}
                  >
                    {item.title}
                  </h3>

                  <p
                    style={{
                      margin: 0,
                      fontFamily: 'Arial, Helvetica, sans-serif',
                      fontSize: '15px',
                      lineHeight: '1.65'
                    }}
                  >
                    {item.text}
                  </p>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* About OvafloPick */}
        <section
          style={{
            padding: '100px clamp(20px, 7vw, 110px)',
            borderBottom: '1px solid #171714'
          }}
        >
          <div
            style={{
              maxWidth: '1250px',
              margin: '0 auto',
              display: 'grid',
              gridTemplateColumns:
                'repeat(auto-fit, minmax(min(100%, 300px), 1fr))',
              gap: 'clamp(40px, 8vw, 120px)'
            }}
          >
            <div>
              <p
                style={{
                  margin: '0 0 24px',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '11px',
                  letterSpacing: '3px',
                  textTransform: 'uppercase'
                }}
              >
                Our marketplace
              </p>

              <h2
                style={{
                  margin: 0,
                  fontSize: 'clamp(48px, 7vw, 96px)',
                  lineHeight: '0.95',
                  fontWeight: 400,
                  letterSpacing: '-0.05em'
                }}
              >
                About OvafloPick
              </h2>
            </div>

            <p
              style={{
                margin: 0,
                alignSelf: 'end',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '19px',
                lineHeight: '1.8'
              }}
            >
              OvafloPick connects you with vetted and trusted custom makers,
              designers and artisans to bring your dream outfit to life. Made to
              Wear is our publication celebrating the craftsmanship, stories and
              creativity behind every piece.
            </p>
          </div>
        </section>

        {/* Why Made to Wear exists */}
        <section
          style={{
            padding: '100px clamp(20px, 7vw, 110px)',
            backgroundColor: '#d8c7ad',
            borderBottom: '1px solid #171714'
          }}
        >
          <div
            style={{
              maxWidth: '1200px',
              margin: '0 auto'
            }}
          >
            <p
              style={{
                margin: '0 0 24px',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '11px',
                letterSpacing: '3px',
                textTransform: 'uppercase'
              }}
            >
              Our purpose
            </p>

            <h2
              style={{
                maxWidth: '900px',
                margin: '0 0 64px',
                fontSize: 'clamp(48px, 8vw, 108px)',
                lineHeight: '0.94',
                fontWeight: 400,
                letterSpacing: '-0.055em'
              }}
            >
              Why we created Made to Wear
            </h2>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns:
                  'repeat(auto-fit, minmax(min(100%, 300px), 1fr))',
                gap: 'clamp(40px, 8vw, 110px)'
              }}
            >
              <div
                style={{
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '18px',
                  lineHeight: '1.8'
                }}
              >
                <p style={{ marginTop: 0 }}>
                  As the name suggests, this is about items made specifically
                  for you; fashion made to be worn and loved for years. At
                  OvafloPick, we believe every handcrafted piece deserves more
                  than a product listing.
                </p>

                <p>
                  The best pieces are not mass-produced. They are designed with
                  intention and crafted by skilled hands, created for people who
                  value personal style over the latest trends.{' '}
                </p>
              </div>

              <div>
                <p
                  style={{
                    margin: 0,
                    fontSize: 'clamp(31px, 4vw, 56px)',
                    lineHeight: '1.15',
                    letterSpacing: '-0.025em'
                  }}
                >
                  Behind every garment is a maker.
                  <br />
                  <br />
                  Behind every stitch is a skill passed through generations.
                  <br />
                  <br />
                  Behind every custom work is a personal story.
                </p>
              </div>
            </div>

            <p
              style={{
                margin: '80px 0 0',
                paddingTop: '28px',
                borderTop: '1px solid #171714',
                fontSize: 'clamp(32px, 5vw, 68px)',
                lineHeight: '1.1'
              }}
            >
              Made to Wear exists to celebrate those stories.
            </p>
          </div>
        </section>

        <section
          style={{
            padding: '100px clamp(20px, 7vw, 110px)',
            backgroundColor: '#f3efe7'
          }}
        >
          <div
            style={{
              maxWidth: '1100px',
              margin: '0 auto'
            }}
          >
            {questionsArticle && (
              <article
                style={{
                  paddingBottom: '80px',
                  borderBottom: '1px solid #171714'
                }}
              >
                <span
                  style={{
                    display: 'block',
                    marginBottom: '20px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    textTransform: 'uppercase'
                  }}
                >
                  Begin Here
                </span>

                <h2
                  style={{
                    maxWidth: '900px',
                    margin: '0 0 28px',
                    fontSize: 'clamp(40px, 7vw, 76px)',
                    fontWeight: 400,
                    lineHeight: '1.02'
                  }}
                >
                  {questionsArticle.title}
                </h2>

                <p
                  style={{
                    maxWidth: '700px',
                    margin: '0 0 34px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '18px',
                    lineHeight: '1.8'
                  }}
                >
                  {questionsArticle.summary}
                </p>

                <a
                  href={`/madetowear/${questionsArticle.slug}`}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '54px',
                    padding: '0 28px',
                    border: '1px solid #171714',
                    color: '#171714',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    textDecoration: 'none',
                    textTransform: 'uppercase'
                  }}
                >
                  Continue Reading →
                </a>
              </article>
            )}

            {processArticle && (
              <article
                style={{
                  padding: '80px 0',
                  borderBottom: '1px solid #171714'
                }}
              >
                <span
                  style={{
                    display: 'block',
                    marginBottom: '20px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    textTransform: 'uppercase'
                  }}
                >
                  Up Next
                </span>

                <h2
                  style={{
                    maxWidth: '900px',
                    margin: '0 0 28px',
                    fontSize: 'clamp(36px, 6vw, 64px)',
                    fontWeight: 400,
                    lineHeight: '1.05'
                  }}
                >
                  {processArticle.title}
                </h2>

                <p
                  style={{
                    maxWidth: '700px',
                    margin: '0 0 28px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '18px',
                    lineHeight: '1.8'
                  }}
                >
                  {processArticle.summary}
                </p>

                <p
                  style={{
                    margin: '0 0 28px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '12px',
                    fontWeight: 700,
                    letterSpacing: '1.5px',
                    textTransform: 'uppercase'
                  }}
                >
                  Join Made to Wear to continue with the next guide.
                </p>

                <a
                  href="#join-made-to-wear"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '54px',
                    padding: '0 28px',
                    border: '1px solid #171714',
                    color: '#171714',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '2px',
                    textDecoration: 'none',
                    textTransform: 'uppercase'
                  }}
                >
                  Continue with Made to Wear
                </a>
              </article>
            )}

            <section
              style={{
                paddingTop: '80px'
              }}
            >
              <span
                style={{
                  display: 'block',
                  marginBottom: '20px',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '11px',
                  fontWeight: 700,
                  letterSpacing: '2px',
                  textTransform: 'uppercase'
                }}
              >
                Why Subscribe?
              </span>

              <h2
                style={{
                  margin: '0 0 34px',
                  fontSize: 'clamp(34px, 5vw, 58px)',
                  fontWeight: 400,
                  lineHeight: '1.05'
                }}
              >
                Begin with clarity. Continue with inspiration.
              </h2>

              <ul
                style={{
                  margin: 0,
                  paddingLeft: '22px',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '18px',
                  lineHeight: '2'
                }}
              >
                <li>Three Begin Here guides</li>
                <li>Weekly editions</li>
                <li>Complete publication archive</li>
              </ul>
            </section>
          </div>
        </section>

        {/* Sign-up */}
        <section
          id="join-made-to-wear"
          style={{
            padding: '110px clamp(20px, 7vw, 110px)',
            backgroundColor: '#171714',
            color: '#f3efe7'
          }}
        >
          <div
            style={{
              maxWidth: '1100px',
              margin: '0 auto',
              display: 'grid',
              gridTemplateColumns:
                'repeat(auto-fit, minmax(min(100%, 300px), 1fr))',
              gap: 'clamp(48px, 8vw, 120px)',
              alignItems: 'end'
            }}
          >
            <div>
              <p
                style={{
                  margin: '0 0 24px',
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '11px',
                  letterSpacing: '3px',
                  textTransform: 'uppercase'
                }}
              ></p>

              <h2
                style={{
                  margin: '0 0 28px',
                  fontSize: 'clamp(42px, 6vw, 72px)',
                  lineHeight: '0.95',
                  fontWeight: 400,
                  letterSpacing: '-0.04em'
                }}
              >
                Become Part of Made to Wear
              </h2>

              <p
                style={{
                  maxWidth: '520px',
                  margin: 0,
                  fontFamily: 'Arial, Helvetica, sans-serif',
                  fontSize: '18px',
                  lineHeight: '1.7'
                }}
              >
                <div
                  style={{
                    maxWidth: '560px',
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    fontSize: '18px',
                    lineHeight: '1.8'
                  }}
                >
                  <p>
                    Join a community that values craftsmanship over mass
                    production.
                  </p>

                  <p>
                    Made to Wear is for people who appreciate thoughtful design,
                    exceptional craftsmanship and the artistry behind
                    custom-made fashion.
                  </p>

                  <p>
                    Every week, discover remarkable makers, practical guidance
                    and inspiring stories that deepen your appreciation for
                    fashion created with intention.
                  </p>
                </div>
              </p>
            </div>
            <p
              style={{
                marginTop: '36px',
                maxWidth: '520px',
                fontFamily: 'Arial, Helvetica, sans-serif',
                fontSize: '17px',
                lineHeight: '1.8'
              }}
            >
              Receive one publication each week.
              <br />
              <br />
              No trends to chase.
              <br />
              No unnecessary noise.
              <br />
              <br />
              Just exceptional craftsmanship, remarkable makers and thoughtful
              stories celebrating fashion made to be worn and loved for years.
            </p>

            <MailchimpForm
  onSubmitted={() => {
    setHasJoined(true)
    window.scrollTo(0, 0)
  }}
/>
          </div>
        </section>
      </main>
    </Content>
  )
}
